var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('mt-header',{staticClass:"header",attrs:{"title":"扫码购订单详情"}},[_c('header-item',{attrs:{"slot":"left","isBack":true},on:{"onclick":_vm.goBack},slot:"left"})],1),_vm._v(" "),_c('order-detail-body')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dcc0d57","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/scanOrder/OrderDetail.vue
// module id = null
// module chunks = 